export const DEPRECATED_REBRAND_PAGE_HEADER_TESTID =
  'rebrand-page-header-testid-will-be-refactored-away';
